import React from 'react';
import PropTypes from 'prop-types';

function LeftStick({ active, activeColor, color }) {
  return (
    <path
      d="M319.63 304.445C319.63 318.717 308.06 330.287 293.788 330.287C279.515 330.287 267.946 318.717 267.946 304.445C267.946 290.173 279.515 278.603 293.788 278.603C308.06 278.603 319.63 290.173 319.63 304.445Z"
      fill={active ? activeColor : color}
    />
  );
}

LeftStick.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

LeftStick.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  color: '#32353A',
};

export default LeftStick;
